module.exports = __webpack_public_path__ + "img/2-2.932a4068.png";